import axiosInstance from '../shared/axiosInstance';
import { serviceConfig } from '../../config';
import { DealershipAdminReqV1 } from './types';

function useUrlQuery(dealershipQuery: DealershipAdminReqV1 | undefined): string | undefined {
  if (dealershipQuery === undefined) {
    return undefined;
  }

  if (dealershipQuery.userId !== undefined && dealershipQuery.userId != '') {
    return `?userId=${dealershipQuery.userId}`;
  }
  if (dealershipQuery.email !== undefined && dealershipQuery.email != '') {
    return `?email=${dealershipQuery.email}`;
  }
  return undefined;
}

async function addDealershipAdmin(queryObject: DealershipAdminReqV1 | undefined): Promise<void> {
  const url = `${serviceConfig.endpoints.legacy.root}${
    serviceConfig.endpoints.legacy.dealerships
  }/dealershipadmin${useUrlQuery(queryObject)}`;
  let result = null;

  try {
    const response = await axiosInstance.put(url);
    result = response.data;
    console.log(result);
  } catch (err) {
    throw new Error('Error retriving the booking with the specified id');
  }

  return result;
}

export default addDealershipAdmin;
